(() => {
  const desktopQuery = window.matchMedia('(min-width: 1200px)');

  function bindThumbnailWheel(root = document) {
    root.querySelectorAll('.yx-product .main-product__rail-thumbs').forEach((rail) => {
      if (rail.dataset.yxDesktopWheelBound === 'true') return;
      rail.dataset.yxDesktopWheelBound = 'true';

      rail.addEventListener('wheel', (event) => {
        if (!desktopQuery.matches) return;

        const delta = event.deltaY || event.deltaX;
        const maxScroll = rail.scrollHeight - rail.clientHeight;
        const atStart = rail.scrollTop <= 0;
        const atEnd = rail.scrollTop >= maxScroll - 1;

        // Keep normal page scrolling available when the thumbnail rail has
        // reached either end; only consume the wheel while it moves photos.
        if (!delta || maxScroll <= 0 || (delta < 0 && atStart) || (delta > 0 && atEnd)) return;

        event.preventDefault();
        rail.scrollBy({ top: delta, behavior: 'auto' });
      }, { passive: false });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindThumbnailWheel(), { once: true });
  } else {
    bindThumbnailWheel();
  }

  document.addEventListener('shopify:section:load', (event) => bindThumbnailWheel(event.target));
})();
